import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MainNavigationService } from '../main-navigation.service';
import { MetaDataService } from '../metadata.service';
import { NGXLogger } from 'ngx-logger';

@Component({
  selector: 'tea-shop-fe-tea-item-list',
  templateUrl: './tea-item-list.component.html',
  styleUrl: './tea-item-list.component.css',
  standalone: false,
})
export class TeaItemListComponent implements OnInit {

  teaItem: any | null = null;
  teaItemProducts: any[] = [];
  teaItemSlug: string;
  errors: string[] = [];

  constructor(
    private route: ActivatedRoute,
    private mainNavigationService: MainNavigationService,
    private metaDataService: MetaDataService,
    private logger: NGXLogger,
  ) {
    this.teaItemSlug = '';
  }

  ngOnInit() {
    this.teaItem = null;
    this.errors = [];
    this.route.params.subscribe(params => {
      const teaItemSlug = params['tea-item-slug']
      this.mainNavigationService.getTeaItem(teaItemSlug).subscribe({
          next: (teaItem: any) => {
            this.teaItem = teaItem;
            // this.images = this.teaItemProduct.teaItemProductImages.sort(
            //   (left, right) => left.position - right.position
            // );
            // if (this.images.length > 0) {
            //   this.setImage(0);
            // }
            // this.contentMap = this.parseMarkdown(this.teaItemProduct.description);
            // this.currentTab = this.getTabs()[0];
            // const teaItem = teaItemProduct.teaItem
            const extraTitle =  teaItem.teaType && teaItem.teaRegion ? ` ${teaItem.teaType.name} from ${teaItem.teaRegion.name}` : '';
            this.metaDataService.updateMetadata({
              title: `${this.teaItem.name}${extraTitle} - Sencha Tea`,
              // image: this.imageUrl,
            });
            // this.logger.log(this.contentMap);
            // this.logger.log(this.tabMap);
          },
          error: (error) => {
            this.logger.error('An error occurred while retrieving the tea item:', error);
            this.errors.push('An error occurred while retrieving the tea item.');
          },
      });
    });
  }
}
